import AddAction from "./addaction";
import ActionCard from "./actioncard";
import Opperation from "./opperataion";
import { WorkflowsDisbatch } from "../../../contexts/workflows";
import { useContext, useEffect, useState } from "react";
import SelectAction from "../../../actions/selectaction";
import EditAction from "../../../actions/editaction";
import EditOpperation from "../../../actions/editopperation";
import useActions from "../../../utils/useactions";
import useWorkflowErrors from "../../../utils/useworkflowerrors";
import { useDrop } from "react-dnd";
import { HiOutlineArrowNarrowDown } from "react-icons/hi";

const ActionEditor = ({ workflow, sources, errorId, setErrorId }) => {
  const disbatch = useContext(WorkflowsDisbatch);
  const [selected, setSelected] = useState(null);
  const [opperation, setOpperation] = useState(null);
  const [_open, setOpen] = useState(false);
  const { actions, types } = useActions();
  const [returnSources, setReturnSources] = useState([]);
  useWorkflowErrors(workflow, sources, (index) => getReturnSources(index));

  const handleSelect = (action) => {
    disbatch({ type: "insert", action, workflow });
    setOpen(false);
    if (!action.children) setSelected(action);
  };

  useEffect(() => {
    if (errorId) {
      const findAction = (actions, actionId) => {
        const _action = actions.find((x) => x.id === actionId);

        if (_action) return _action;

        let tempAction = null;
        actions.forEach((a) => {
          if (a.children) {
            a.children.forEach((child) => {
              const _found = findAction(child.actions, actionId);
              tempAction = _found;
            });
          }
        });
        return tempAction;
      };

      setSelected(findAction(workflow.actions, errorId));
      setErrorId(null);
    }
  }, [errorId]);

  useEffect(() => {
    if (selected) {
      const findIndex = workflow.actions.findIndex((x) => x.id === selected.id);

      if (findIndex < 0) {
        setReturnSources([]);
        return;
      }

      const _sources = getReturnSources(findIndex);
      setReturnSources(_sources);
    } else if (opperation) {
      const findIndex = workflow.actions.findIndex(
        (x) => x.id === opperation.id
      );

      if (findIndex < 0) {
        setReturnSources([]);
        return;
      }

      const _sources = getReturnSources(findIndex);
      console.log(_sources);
      setReturnSources(_sources);
    } else {
      setReturnSources([]);
    }
  }, [selected, opperation, workflow]);

  const getReturnSources = (index) => {
    const sources = [];
    workflow.actions.forEach((action, i) => {
      if (action.return && i < index) {
        action.return.forEach((r) => {
          let returnType = { ...action.props };
          r.type.split(".").forEach((x) => {
            try {
              returnType = returnType[x];
            } catch (err) {
              returnType = null;
            }
          });
          const getReturnList = (list) => {
            try {
              let returnList = { ...action.props };
              r.list.split(".").forEach((x) => {
                returnList = returnList[x];
              });
              return returnList;
            } catch (err) {
              return list;
            }
          };
          console.log("Return Type", returnType);
          sources.push({
            name: `${r.name}`,
            code: `_${i}.${r.name}`,
            params: [],
            returnType: returnType ? returnType : r.type,
            returnList: getReturnList(r.list),
            category: action.name,
          });
        });
      }
    });
    return sources;
  };

  const handleUpdate = (action) => {
    const findIndex = workflow.actions.findIndex((x) => x.id === action.id);
    disbatch({ type: "updateAction", workflow, action, index: findIndex });
    setSelected(null);
    setOpperation(null);
  };

  const handleDelete = (index) => {
    disbatch({ type: "deleteAction", workflow, index });
  };

  const handleDrop = (action, fromPath, toPath) => {
    const _actions = [...workflow.actions];

    const shortIndex =
      fromPath.length < toPath.length ? fromPath.length - 1 : toPath.length - 1;
    const dragUp = fromPath[shortIndex] >= toPath[shortIndex];

    const remove = () => {
      let holder = _actions;
      fromPath.forEach((p, index) => {
        if (index < fromPath.length - 1) {
          holder = holder[p];
        } else {
          holder.splice(p, 1);
        }
      });
    };

    const insert = () => {
      let toholder = _actions;
      toPath.forEach((p, index) => {
        if (index < toPath.length - 1) {
          console.log(toholder, p);
          toholder = toholder[p];
        } else {
          toholder.splice(p + 1, 0, action);
        }
      });
    };

    if (dragUp) {
      //remove then insert
      remove();
      insert();
    } else {
      //insert then remove
      insert();
      remove();
    }

    const _workflow = { ...workflow, actions: _actions };
    disbatch({ type: "update", workflow: _workflow });
  };

  const topDrop = (item, monitor) => {
    if (!monitor.isOver({ shallow: true })) {
      return;
    }
    handleDrop(item.action, item.path, [-1]);
  };

  const [{ hovered }, dropRef] = useDrop({
    accept: "action",
    drop: topDrop,
    collect: (monitor) => ({
      hovered: !!monitor.isOver({ shallow: true }) && monitor.canDrop(),
    }),
  });

  return (
    <div
      style={{
        borderRadius: 3,
        width: "fit-content",
        boxSizing: "border-box",
        flexDirection: "column",
        alignItems: "center",
        overflow: "visible",
        display: "flex",
        margin: 15,
      }}
    >
      <div ref={dropRef} style={{ width: 300 }}>
        <div
          style={{
            padding: 15,
            backgroundColor: "white",
            borderRadius: 8,
          }}
        >
          Workflow is Triggered
        </div>
        <div
          style={{
            color: "#333",
            fontSize: 24,
            marginTop: 8,
            width: "fit-content",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: hovered ? 48 : 0,
          }}
        >
          <HiOutlineArrowNarrowDown />
        </div>
      </div>
      {workflow.actions.map((a, i) => {
        if (a.children) {
          const _sources = getReturnSources(i);
          return (
            <Opperation
              getReturnSources={getReturnSources}
              onChange={handleUpdate}
              key={a.id}
              sources={[..._sources, ...sources]}
              opperation={a}
              path={[i]}
              onDelete={() => handleDelete(i)}
              onDrop={handleDrop}
              onClick={() => setOpperation(a)}
              index={i}
              actions={actions}
              types={types}
            />
          );
        }
        return (
          <ActionCard
            getReturnSources={getReturnSources}
            key={a.id}
            onDrop={handleDrop}
            path={[i]}
            action={a}
            index={i}
            onClick={() => setSelected(a)}
            onDelete={() => handleDelete(i)}
          />
        );
      })}
      <AddAction onClick={() => setOpen(true)} />
      <EditAction
        action={selected}
        onSave={handleUpdate}
        actions={actions}
        onClose={() => setSelected(false)}
        sources={[...returnSources, ...sources]}
      />
      <SelectAction
        open={_open}
        onClose={() => setOpen(false)}
        onSelect={handleSelect}
        actions={actions}
        types={types}
      />
      <EditOpperation
        actions={actions}
        sources={[...returnSources, ...sources]}
        opperation={opperation}
        onClose={() => setOpperation(null)}
        onSave={handleUpdate}
      />
    </div>
  );
};

export default ActionEditor;
